import sickBabyBackground from '@assets/images/sick_baby_background.png';
import BackgroundImage from '@components/BackgroundImage';
import FocusableButton from '@components/FocusableButton';
import Loading from '@components/Loading';
import Navigation from '@components/Navigation';
import { useBackHandlerContext } from '@context/BackHandler';
import { useTreatmentHistoryContext } from '@context/TreatmentHistory';
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect, useLayoutEffect } from 'react';

import { TREATMENT_HISTORY_VIEW } from '../focusKey';
import EmptyList from './components/EmptyList';
import TreatmentList from './components/TreatmentList';

import * as styles from './styles';

const TreatmentHistoryView = () => {
  const {
    loaderVisible,
    setLoaderVisibility,
    completionTreatments,
    refreshTreatmentHistory,
    isLoading,
    goHome
  } = useTreatmentHistoryContext();

  const { addCallback } = useBackHandlerContext();

  useLayoutEffect(() => {
    return addCallback(() => {
      goHome();
      return false;
    });
  }, [addCallback, goHome]);

  useEffect(() => {
    setLoaderVisibility();
  }, [setLoaderVisibility]);

  return (
    <FocusContext.Provider value={TREATMENT_HISTORY_VIEW}>
      <div css={styles.mainContainer}>
        <section css={styles.navContainer}>
          <Navigation />
        </section>
        <section css={styles.contentContainer}>
          <div css={styles.contentTopContainer}>
            <p css={styles.title}>진료내역</p>
            <FocusableButton
              onEnterPress={refreshTreatmentHistory}
              buttonStyle={styles.refreshButton}
            >
              새로고침
            </FocusableButton>
          </div>
          {/* TODO: change to FocusableContentRow */}
          {/* TODO: split into loading indicator */}
          {isLoading || (completionTreatments && completionTreatments.length > 0) ? (
            <TreatmentList />
          ) : (
            <EmptyList />
          )}
        </section>
        <BackgroundImage url={sickBabyBackground} filter={'blur(20px)'} />
      </div>
      <Loading visible={loaderVisible} />
    </FocusContext.Provider>
  );
};

export default TreatmentHistoryView;
